var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.5,
    height: 32.214,
    viewBox: "0 0 36.5 32.214",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3426.458 -1034.311)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#00615c",
    d: "M3435.065,1043.668h-7.857a.75.75,0,0,1-.75-.75v-7.857a.75.75,0,0,1,.75-.75h7.857a.75.75,0,0,1,.75.75v7.857A.75.75,0,0,1,3435.065,1043.668Zm-7.107-1.5h6.357v-6.357h-6.357Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00615c",
    d: "M3448.637,1043.668h-7.857a.75.75,0,0,1-.75-.75v-7.857a.75.75,0,0,1,.75-.75h7.857a.75.75,0,0,1,.75.75v7.857A.75.75,0,0,1,3448.637,1043.668Zm-7.107-1.5h6.357v-6.357h-6.357Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00615c",
    d: "M3462.208,1043.668h-7.857a.75.75,0,0,1-.75-.75v-7.857a.75.75,0,0,1,.75-.75h7.857a.749.749,0,0,1,.75.75v7.857A.75.75,0,0,1,3462.208,1043.668Zm-7.107-1.5h6.357v-6.357H3455.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00615c",
    d: "M3435.065,1055.1h-7.857a.75.75,0,0,1-.75-.75v-7.858a.75.75,0,0,1,.75-.75h7.857a.75.75,0,0,1,.75.75v7.858A.75.75,0,0,1,3435.065,1055.1Zm-7.107-1.5h6.357v-6.358h-6.357Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00615c",
    d: "M3448.637,1055.1h-7.857a.75.75,0,0,1-.75-.75v-7.858a.75.75,0,0,1,.75-.75h7.857a.75.75,0,0,1,.75.75v7.858A.75.75,0,0,1,3448.637,1055.1Zm-7.107-1.5h6.357v-6.358h-6.357Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00615c",
    d: "M3462.208,1055.1h-7.857a.75.75,0,0,1-.75-.75v-7.858a.75.75,0,0,1,.75-.75h7.857a.75.75,0,0,1,.75.75v7.858A.75.75,0,0,1,3462.208,1055.1Zm-7.107-1.5h6.357v-6.358H3455.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00615c",
    d: "M3435.065,1066.525h-7.857a.75.75,0,0,1-.75-.75v-7.857a.75.75,0,0,1,.75-.75h7.857a.75.75,0,0,1,.75.75v7.857A.75.75,0,0,1,3435.065,1066.525Zm-7.107-1.5h6.357v-6.357h-6.357Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00615c",
    d: "M3448.637,1066.525h-7.857a.75.75,0,0,1-.75-.75v-7.857a.75.75,0,0,1,.75-.75h7.857a.75.75,0,0,1,.75.75v7.857A.75.75,0,0,1,3448.637,1066.525Zm-7.107-1.5h6.357v-6.357h-6.357Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00615c",
    d: "M3462.208,1066.525h-7.857a.75.75,0,0,1-.75-.75v-7.857a.75.75,0,0,1,.75-.75h7.857a.75.75,0,0,1,.75.75v7.857A.75.75,0,0,1,3462.208,1066.525Zm-7.107-1.5h6.357v-6.357H3455.1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationsIcon);
export default __webpack_public_path__ + "static/media/applications-icon.176d5ddfe6dd4fafec701e3c26125610.svg";
export { ForwardRef as ReactComponent };